import React, {VoidFunctionComponent} from "react";

interface Props {
    index: number,
    date: string,
    amount: string,
    isLinked?: boolean,
    id: string
}

export const ScheduleItems: VoidFunctionComponent<Props> = ({index, date, amount, isLinked = true, id}) => {
    return (
        <div className='schedule-item' id={id}>
            <div className='item'>
                <div className='circle'>
                    <p>{index}</p>
                </div>
                <p className='date' id={date}></p>
                <p className='green-cetelem' id={amount}></p>
            </div>
            {isLinked && <div className='link'/>}
        </div>
    );
};